const updateQueryParams = ({ history, location, newParams }) => {
  const searchParams = new URLSearchParams();

  Object.entries(newParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.set(key, String(value));
    }
  });

  const newSearch = searchParams.toString();
  const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ""}`;

  history.replace(newUrl);
};

export default updateQueryParams;
